import { z } from 'zod';
import { MarketCodeSchema } from '@sharpr/types/validation';

// The one player-id grammar: PlayerIdSchema and the scenario key (scenario.ts) are both built from it.
export const PLAYER_ID = '[1-9]\\d*';

export const PlayerIdSchema = z.string().regex(new RegExp(`^${PLAYER_ID}$`));
export type PlayerId = z.infer<typeof PlayerIdSchema>;
export const TeamIdSchema = z.string().min(1).max(32);
export type TeamId = z.infer<typeof TeamIdSchema>;
export const GameIdSchema = z.string().regex(/^\d{1,16}$/);
export type GameId = z.infer<typeof GameIdSchema>;
export { MarketCodeSchema };
// Structural only: the Python-wire documents (artifact, runner input) carry it, and Python validates calendar dates itself.
export const SlateDatePatternSchema = z.string().regex(/^\d{4}-\d{2}-\d{2}$/);
// A real calendar date; for the TS boundaries (routes, admin actions) that take a slate date from a caller.
export const SlateDateSchema = SlateDatePatternSchema.refine(d => {
  const t = new Date(`${d}T00:00:00Z`);
  return !Number.isNaN(t.getTime()) && t.toISOString().slice(0, 10) === d;
}, 'not a calendar date');
export const IsoDateTimeSchema = z.iso.datetime({ offset: true });

// A model run: its model_runs.id, the name of everything the run stores.
export const RunIdSchema = z.uuid();
